// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-chooser{border:1px solid #000;float:left;height:91px;margin-bottom:5px;text-align:center;width:300px}.image-chooser:before{content:\" \";display:inline-block;height:100%;vertical-align:middle}.image-chooser img{max-height:80%;max-width:70%}", ""]);
// Exports
module.exports = exports;
